export const decorateColumns = (columns, sizes) => columns.map((column, index) => ({
  ...column,
  className: column.accessor,
  width: sizes[index],
}));
